import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const EquipoPublico = () => {
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal ? `http://${window.location.hostname}:3001` : `https://${window.location.hostname}`;
  const { codigo } = useParams();
  const [equipo, setEquipo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEquipo = async () => {
      if (!codigo) return;
      try {
        const resp = await fetch(`${apiBase}/api/publico/equipo/${codigo}`);
        if (resp.ok) {
          setEquipo(await resp.json());
        } else {
          setError('El equipo escaneado no fue encontrado o no existe en nuestras bases.');
        }
      } catch(err) {
        setError('Error contactando al servidor maestro.');
      }
    };
    fetchEquipo();
  }, [apiBase, codigo]);

  if (error) return <div style={{textAlign: 'center', padding: '50px', fontFamily: 'sans-serif', color: '#dc3545'}}><h3>{error}</h3></div>;
  if (!equipo) return <div style={{textAlign: 'center', padding: '50px', fontFamily: 'sans-serif'}}><h3>Leyendo Etiqueta QR...</h3></div>;

  return (
    <div style={{fontFamily: 'Arial, sans-serif', maxWidth: '100%', margin: 0, padding: '20px', backgroundColor: '#f4f7fa', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <div style={{backgroundColor: 'white', borderRadius: '12px', padding: '30px', boxShadow: '0 8px 30px rgba(0,0,0,0.08)', width: '100%', maxWidth: '600px', margin: '20px auto'}}>
        <div style={{textAlign: 'center', marginBottom: '25px', borderBottom: '2px solid #0d6efd', paddingBottom: '15px'}}>
           <h1 style={{color: '#0d6efd', margin: '0 0 5px 0', fontSize: '26px'}}>Ficha Técnica Activo Fijo</h1>
           <span style={{color: '#666', fontSize: '15px', fontWeight: 'bold'}}>Sistema de Gestión Municipal</span>
        </div>
        
        <div style={{marginTop: '20px', fontSize: '16px', lineHeight: '2.0'}}>
           <div style={{background: '#f8f9fa', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #eee', textAlign: 'center'}}>
             <span style={{display: 'block', fontSize: '13px', color: '#666', textTransform: 'uppercase', letterSpacing: '1px'}}>Nro. Serie / Código</span>
             <span style={{fontSize: '32px', color: '#333', fontWeight: 'bold', fontFamily: 'monospace'}}>{equipo.codigo}</span>
           </div>
           
           <p style={{borderBottom: '1px solid #f1f1f1', paddingBottom: '10px'}}><strong>Módelo / Denominación:</strong> <span style={{float: 'right', color: '#0d6efd', fontWeight: '500'}}>{equipo.modelo}</span></p>
           <p style={{borderBottom: '1px solid #f1f1f1', paddingBottom: '10px'}}><strong>Clasificación:</strong> <span style={{float: 'right'}}>{equipo.categoria}</span></p>
           <p style={{borderBottom: '1px solid #f1f1f1', paddingBottom: '10px'}}>
              <strong>Estado Físico:</strong> 
              <span style={{float: 'right', background: equipo.estado === 'Operativo' ? '#20c997' : equipo.estado === 'Reparación' ? '#fd7e14' : '#dc3545', color: 'white', padding: '2px 10px', borderRadius: '12px', fontSize: '13px', fontWeight: 'bold'}}>
                {equipo.estado}
              </span>
           </p>
           <p style={{borderBottom: '1px solid #f1f1f1', paddingBottom: '10px'}}><strong>Asignado Oficialmente A:</strong> <span style={{float: 'right', fontWeight: 'bold', color: '#333'}}>{equipo.custodio_uid || 'En Bodega'}</span></p>
           
           <div style={{marginTop: '25px', padding: '20px', backgroundColor: '#fff', borderRadius: '8px', borderLeft: '4px solid #0d6efd', boxShadow: '0 2px 10px rgba(0,0,0,0.05)'}}>
             <strong style={{color: '#0d6efd', display: 'flex', alignItems: 'center', gap: '8px'}}>Notas y Observaciones</strong>
             <p style={{margin: '10px 0 0 0', color: '#555', fontStyle: equipo.detalle ? 'normal' : 'italic'}}>{equipo.detalle || 'No hay notas técnicas ingresadas para este dispositivo.'}</p>
           </div>
        </div>
      </div>
      
      <div style={{marginTop: '20px', color: '#aaa', fontSize: '13px'}}>
        Gestor de Equipos Institucional - Escaneo Válido
      </div>
    </div>
  );
};
export default EquipoPublico;
